<template>
    <div>
        <b-form-group label="COUNTRY" label-class="text-truncate label-required">
            <country-select class="form-control"
                            v-model="country"
                            :country="country"
                            topCountry="US"
                            required
                            ref="countrySelect"
                            :countryName="true"/>
        </b-form-group>

        <b-form-group label="ADDRESS LINE 1" label-class="text-truncate label-required" label-for="input-line1">
            <b-form-input v-model="line1" required id="input-line1"/>
        </b-form-group>

        <b-form-group label="ADDRESS LINE 2" label-class="text-truncate">
            <b-form-input v-model="line2"/>
        </b-form-group>

        <b-form-group label="CITY" label-class="text-truncate label-required">
            <b-form-input v-model="city" required/>
        </b-form-group>

        <b-row>
            <b-col lg="6">
                <b-form-group label="STATE" label-class="text-truncate label-required">
                    <region-select :regionName="true"
                                   :countryName="true"
                                   class="form-control"
                                   v-model="state"
                                   required
                                   :country="country"
                                   :region="state"/>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="ZIP" label-class="text-truncate label-required">
                    <b-form-input v-model="zip" required/>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
  props: ['organization'],

  data: function () {
    return {
      line1: null,
      line2: null,
      country: null,
      state: null,
      city: null,
      zip: null
    }
  },

  watch: {
    organization(org) {
      this.updateWithOrganization(org);
    },

    stripeParams(value) {
      this.$emit("stripeParamsChange", value)
    },

    params(value) {
      this.$emit("organizationParamsChange", value)
    }
  },

  created() {
    this.updateWithOrganization(this.organization)
  },

  methods: {
    updateWithOrganization: function (organization) {
      if (organization) {
        this.line1 = organization.billing_address_line_1;
        this.line2 = organization.billing_address_line_2;
        this.country = organization.billing_country;
        this.state = organization.billing_state;
        this.city = organization.billing_city;
        this.zip = organization.billing_zip;
      }
    },

    countryShortCode() {
      if (this.$refs.countrySelect) {
        if (this.country === 'United States') {
          return 'US'
        }

        const country = this.$refs.countrySelect.countries.find(c => c.countryName === this.country)
        return country ? country.countryShortCode : null
      }
      return null
    }
  },

  computed: {
    params() {
      return {
        billing_address_line_1: this.line1,
        billing_address_line_2: this.line2,
        billing_country: this.country,
        billing_state: this.state,
        billing_city: this.city,
        billing_zip: this.zip
      }
    },

    stripeParams() {
      return {
        city: this.city,
        line1: this.line1,
        line2: this.line2,
        country: this.countryShortCode(),
        state: this.state,
        postal_code: this.zip
      }
    }
  }
}
</script>